import script from "./ComingSoonStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoonStrip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__